import { render, staticRenderFns } from "./EdicionPrecios.vue?vue&type=template&id=3fa62463&scoped=true"
import script from "./EdicionPrecios.vue?vue&type=script&lang=js"
export * from "./EdicionPrecios.vue?vue&type=script&lang=js"
import style0 from "./EdicionPrecios.vue?vue&type=style&index=0&id=3fa62463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa62463",
  null
  
)

export default component.exports